import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { func, node } from 'prop-types';
import CheckCircleFilled from '@s7/ui-kit/icons/CheckCircleFilled';
import classNames from 'classnames/bind';
import styles from './Popup.css';
import { dictKeys, getTestIdGetter } from '../utils/testIds';
var cx = classNames.bind(styles);
var getTestId = getTestIdGetter(dictKeys.LOGIN);

var Popup = function Popup(_ref) {
  var text = _ref.text,
      clearPopup = _ref.clearPopup;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root'),
    onClick: clearPopup
  }, getTestId('passwordRecoveryPopup')), /*#__PURE__*/React.createElement("div", {
    className: cx('icon')
  }, /*#__PURE__*/React.createElement(CheckCircleFilled, null)), /*#__PURE__*/React.createElement("div", {
    className: cx('text')
  }, text));
};

Popup.propTypes = {
  text: node,
  clearPopup: func
};
export default Popup;